import { MDBModal, MDBModalBody, MDBModalHeader } from 'mdbreact'
import React, { useState } from 'react'
import EditPlayerSquadForm from '../EditPlayerSquadForm'

function EditPlayerSquadListTemplate({ player, teamId }) {
    const [show, setShow] = useState(false)

    function toggleModal() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    return (
        <div>
            <p>
                <img
                    src={player.player_image}
                    className="img-fluid rounded-circle"
                    style={{ maxWidth: '30px' }}
                    alt={player.player_name}
                />
                {player.player_name}
                <span className="float-right">
                    <button
                        className="btn btn-sm btn-rounded btn-info"
                        onClick={() => setShow(true)}
                    >
                        Rediger
                    </button>
                </span>
            </p>

            <MDBModal size="xl" isOpen={show} toggle={toggleModal}>
                <MDBModalHeader toggle={toggleModal}>Rediger</MDBModalHeader>
                <MDBModalBody>
                    <EditPlayerSquadForm
                        player={player}
                        playerId={player.id}
                        setShowEdit={setShow}
                        teamId={teamId}
                    />
                </MDBModalBody>
            </MDBModal>
        </div>
    )
}
export default EditPlayerSquadListTemplate
